import ajax from '../ajax';

// 获取表格数据
export const getDemoTableMock = (data: any) => ajax('/mock/demoTable', data, 'GET');
